import { type DropzoneOptions, useDropzone } from 'react-dropzone';

import { useUploadAsset } from './asset-upload-modal';
import { type AllowedFileCategory } from './utils';

export function useAssetDropzone(
  allowedFileCategories?: AllowedFileCategory[],
  parentFolderId?: string | null,
  parentFolderName?: string,
  onSuccessfulUpload?: () => void,
  options?: Omit<DropzoneOptions, 'onDrop'>,
) {
  const [, { uploadFiles }] = useUploadAsset();

  const categories = allowedFileCategories ?? ['image', 'doc'];

  const accept: Record<string, string[]> = {};
  if (categories.includes('image')) {
    accept['image/bmp'] = ['.bmp'];
    accept['image/gif'] = ['.gif'];
    accept['image/jpeg'] = ['.jpg', '.jpeg'];
    accept['image/png'] = ['.png'];
  }
  if (categories.includes('doc')) {
    accept['application/pdf'] = ['.pdf'];
  }

  return useDropzone({
    noClick: true,
    noKeyboard: true,
    accept: Object.keys(accept).length > 0 ? accept : undefined,
    ...options,
    onDrop: (acceptedFiles) =>
      uploadFiles(acceptedFiles, {
        parentFolderId,
        parentFolderName,
        allowedFileCategories,
        onSuccessfulUpload,
      }),
  });
}
